import { Backdrop as BackdropMui, Button, Popper as PopperMui } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const Popper = styled(PopperMui)`
  position: relative;
  z-index: 2200;
  width: 400px;
`;

export const Header = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  align-items: center;
`;

export const ResetEndedCalls = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ResetButton = styled(Button)``;

export const Backdrop = styled(BackdropMui)(({ theme }) => ({
  background: alpha(theme.palette.common.white, 0.8),
}));

export const BackdropWrapper = styled('div')`
  position: relative;
  min-height: 48px;
`;
